if (!customElements.get('aq-cart-recommendations')) {
  customElements.define('aq-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.fallback = [...this.querySelectorAll('li[data-product-id]')].map((node) => node.cloneNode(true));
      this.generation = 0;
      this.refresh();
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.controller?.abort();
    }
    async fetchCards(productId, intent, signal) {
      const url = new URL(this.dataset.url, location.origin);
      url.search = new URLSearchParams({ section_id: this.dataset.sectionId, product_id: productId, limit: 10, intent });
      const response = await fetch(url, { signal });
      if (!response.ok) return [];
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      return [...html.querySelectorAll('aq-cart-recommendations li[data-product-id]')];
    }
    async refresh() {
      const generation = ++this.generation;
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      try {
        const response = await fetch(this.dataset.cartUrl, { signal, cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        const excluded = new Set(cart.items.map((item) => String(item.product_id)));
        const seeds = [...excluded].slice(0, 3);
        const groups = await Promise.all(seeds.map(async (id) => {
          try {
            const complementary = await this.fetchCards(id, 'complementary', signal);
            const usable = complementary.filter((node) => !excluded.has(node.dataset.productId));
            return usable.length ? usable : await this.fetchCards(id, 'related', signal);
          } catch { return []; }
        }));
        if (generation !== this.generation || !this.isConnected) return;
        const selected = [];
        const seen = new Set(excluded);
        const append = (node) => {
          if (selected.length < 4 && !seen.has(node.dataset.productId)) {
            seen.add(node.dataset.productId);
            selected.push(node.cloneNode(true));
          }
        };
        for (let index = 0; index < 10; index++) groups.forEach((group) => { if (group[index]) append(group[index]); });
        const tailored = selected.length > 0;
        if (!tailored) this.fallback.forEach(append);
        this.querySelector('.aq-product-grid').replaceChildren(...selected);
        this.querySelector('h2').textContent = tailored ? this.dataset.heading : this.dataset.fallbackHeading;
        this.hidden = selected.length === 0;
      } catch (error) {
        if (error.name !== 'AbortError') this.querySelector('h2').textContent = this.dataset.fallbackHeading;
      }
    }
  });
}
